import createMetadataAPITypes from '../../utils/api-metadata-types';
import { snakeCase } from 'lodash';

const options = {
  name: 'authorization',
  baseType: 'AUTHORIZATION',
  apiEndpoint: 'authorization'
};

const types = createMetadataAPITypes(options);

const initialState = {
  permissions: {},
  loading: false,
  lastFetch: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.START: {
      return { ...state, loading: true };
    }
    case types.SUCCESS: {
      const permissionsHash = {};
      for (const permission of action.payload.data || []) {
        const { object_type, action, can, ...rest } = permission;
        const query = Object.entries(rest)
          .map(([key, value]) => `${key}_${value}`)
          .join('_');
        const key = `${action}_${snakeCase(object_type)}_${query}`;
        permissionsHash[key] = can;
      }

      return {
        ...state,
        permissions: { ...state.permissions, ...permissionsHash },
        loading: false,
        lastFetch: action.timestamp
      };
    }
    case types.ERROR: {
      // we still want to leave existing data intact as well as "last fetch"
      // which would let us determine if the data is stale or not
      const errorTimes = [...(state.errorTimes || []), action.timestamp];
      return {
        ...state,
        error: action.error,
        errorTimes,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};
